function shareIcon() {
  const copyLinks = document.querySelectorAll('.copy-link');

  copyLinks.forEach(copyLink => {
    const copyLinkIcon = copyLink.querySelector('.share-icon');
    const copiedInfo = copyLink.querySelector('.link-copied-info');

    let timer;
    copyLink.addEventListener('click', () => {
      navigator.clipboard.writeText(window.location.href);

      clearTimeout(timer);
      copiedInfo.classList.remove('display-none');
      copyLinkIcon.classList.add('bounce');

      timer = setTimeout(() => {
        copiedInfo.classList.add('display-none');
        copyLinkIcon.classList.remove('bounce');
      }, 2000);
    });
  });
}
